export class StatsTableState {
  constructor() {
    this.open = true;
  }
}
